<template>
  <div class="leave-dialog">
    <div class="box">
      <div class="title">{{ $t("studentProgramme.leaveTitle") }}</div>
      <div class="content"></div>
      <div class="content">{{ leaveMessage }}</div>
      <div class="btn">
        <el-button type="info"  round @click="returnTo">{{ $t("studentProgramme.cancel") }}</el-button>
        <el-button type="warning"  round @click="leave">{{ $t("studentProgramme.confirm") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['leaveMessage', 'mode'],
  data() {
    return {

    }
  },
  methods: {
    returnTo() {
      this.$emit('closeDialog')
    },
    leave() {
      // 评估 assessments, 作业 work, 冒险(课题，小测) adventure, 图书馆(練習) library
      this.returnTo()
      let { type, isSmallTest } = this.$route.query

      // 处理类型  type=adventure&topicId=12&id=12&gradeId=1&isSmallTest=true
      if(isSmallTest != undefined) {
        type = isSmallTest == 'false' ? 'library' : 'adventure'
      }
      // 处理类型 
      if(isSmallTest != undefined) {
        if(isSmallTest == 'false') {
          type = 'library'
          window.sessionStorage.isSmallTest = "false";
        } else {
          type = 'adventure'
          window.sessionStorage.isSmallTest = "true";
        }
      }
      console.log(type, this.mode)
      // 提交过做题答案 且是adventure类型 isLoaded 为 "true" 其余情况都为false
      if(type == 'adventure' && this.mode == 'viewAnswer') {
        window.sessionStorage.triviaQuiz = "true";
      } else{
        window.sessionStorage.triviaQuiz = "false";
      }
      window.sessionStorage.isLoaded = "false";
      if(type == 'assessments') this.$router.push('/adventure');
      else this.$router.go(-1);
    }
  }
}
</script>

<style scoped lang="scss">
.leave-dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  .box {
    width: 400px;
    height: 230px;
    background-color: #fff;
    border-radius: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    padding: 20px 0;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 30px;
      text-align: center;
      color: #B62D2E;
      font-weight: 700;
    }

    .content {
      font-size: 20px;
      width: 100%;
      text-align: center;
      padding-bottom: 30px;
    }

    .btn {
      width: 100%;
      display: flex;
      justify-content: center;

      img {
        height: 50px;
        width: auto;
        margin: 0 10px;
        cursor: pointer;

        &:hover {
          opacity: .7;
        }
      }
    }
  }
}
</style>